/**
 * Created by 58 on 2017/4/19.
 */
var XssFilter = function () {

};

XssFilter.prototype.doFilter = function (input) {
    // xssFilter,将'<'替换成’&lt;  将'>'替换成&gt;
    var output;
    try{
      output = input.replace(/\<script/gi, '&lt;script').replace(/script\>/gi, 'script&gt;').replace(/\<\/script/gi,'&lt;/script');
    }
    catch(e){
      output = input;
    }
    return output;
};
XssFilter.prototype.resetFilter = function (input) {
    // xssFilter,将&lt;替换成'<' ,将&gt;替换成'>'
    var output = input.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
    return output;
};

module.exports = new XssFilter;
